import React from "react"

import { Row, Col, Form, Button } from "react-bootstrap"
import { partyGrouping } from "../../data/formOptions"

const MultiGrouping = props => {
  const { values, setGrouping, nextStep } = props
  

  const setGroupingAndNext = type => {
    setGrouping(type)
    nextStep()
  }

  return (
    <div style={{ textAlign: "center" }}>
      {/* <---------------Q1--------------->*/}
      <Row style={{ justifyContent: "center" }}>
        <Col xs={12} sm={6}>
          <Form.Label className="button-question">
            Who is the cover for?
          </Form.Label>

          {/* <---------------BUTTON--------------->*/}
          <Row>
            <Col
              sm={4}
              xs={{ offset: 2, span: 4 }}
              style={{ textAlign: "center" }}
            >
              <div>
                <Button
                  // type="button"
                  className="orange-btn"
                  onClick={() => setGroupingAndNext(partyGrouping.me)}
                  active={values.grouping === partyGrouping.me ? true : false}
                >
                  <i className="fas fa-user fa-2x"></i>
                </Button>
              </div>
              <Form.Label className="button-label">Me</Form.Label>
            </Col>
            {/* <---------------BUTTON--------------->*/}
            <Col sm={4} xs={4} style={{ textAlign: "center" }}>
              <div>
                <Button
                  // type="button"
                  className="orange-btn"
                  onClick={() => setGroupingAndNext(partyGrouping.plusOne)}
                  active={
                    values.grouping === partyGrouping.plusOne ? true : false
                  }
                >
                  <i className="fas fa-user-friends fa-2x"></i>
                </Button>
              </div>
              <Form.Label className="button-label">Myself + 1</Form.Label>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default MultiGrouping
